import GamedayApiService from "./gameday-api-service";
import SecurityService from "./security-service";
import EventStatus, { EventStatusCode } from "../sports/common/event-status";
import ContextService from "./context-service";
import GameService from "./game-service";
import { getAllowedSportCodes } from "./common/config-util";

class HomeService {
    async getEventsSummary(date, sportCodes = []) {
        const allowedSportCodes = sportCodes?.length
            ? sportCodes
            : getAllowedSportCodes();

        // This is to make sure remote seasons are present in the local db at the time we return the event summary.
        // Required for event actions access.
        const seasons = await GamedayApiService.getSeasons(sportCodes);

        let events = [];
        for (const sportCode of allowedSportCodes) {
            const allEvents =
                await GamedayApiService.getEventsByDateSportCodeAndStatusCode(
                    date,
                    sportCode,
                    ["IN_PROGRESS", "NOT_STARTED", "FINAL"]
                );

            for (const event of allEvents) {
                if (EventStatus.isInProgress(event)) {
                    const foundGame = await GameService.getGameByEventId(
                        event.id
                    );
                    if (foundGame) {
                        const gameContext = await ContextService.getGameContext(
                            foundGame.id
                        );
                        if (gameContext) {
                            event.score.home = `${gameContext.score[0]}`;
                            event.score.away = `${gameContext.score[1]}`;
                        }
                    }
                }
            }

            events = allEvents.sort(
                (a, b) =>
                    b.statusCode === EventStatusCode.IN_PROGRESS ||
                    a.statusCode - b.statusCode
            );
        }

        return Promise.all(
            events.map((event) => this.getExtendedEvent(seasons, event))
        );
    }

    async getExtendedEvent(seasons, event) {
        const gameAccess =
            (await SecurityService.getEventAccess(event.id)) || [];
        const season = seasons.find((s) => s.seasonId === event.seasonId);

        return Object.assign(event, { gameAccess, season });
    }
}

export default new HomeService();
